import {
    BACKEND_KEYS,
    numberTelusWifiAccessPointsTelusBusiness,
    telusBusinessWifiType
} from '../../../utils/constant';
import getFieldValue from './getFieldValue';
import { getFieldPriceOrLabel } from './secureBusiness';

export default (fields, steps) => {
    const {
        fields: { formStepFields }
    } = steps.find(s => s.fields.backendKey === BACKEND_KEYS.telusBusinessWifiHSIA);

    let wifiAccessMonthly = 0;
    let wifiAccessOneTime = 0;
    const product = {
        wifiAccess: []
    };

    const valueNumberTelusWifiAccessPointsTelusBusiness = getFieldValue(
        numberTelusWifiAccessPointsTelusBusiness,
        fields
    )

    const valueTelusBusinessWifiType = getFieldValue(
        telusBusinessWifiType,
        fields
    )

    if (valueTelusBusinessWifiType) {
        product.telusBusinessWifiType = {
            value: getFieldPriceOrLabel(formStepFields, valueTelusBusinessWifiType, false),
        };
    }

    if (valueNumberTelusWifiAccessPointsTelusBusiness > 0) {
        product.wifiAccess.push({
            value: getFieldPriceOrLabel(formStepFields, numberTelusWifiAccessPointsTelusBusiness, false),
            qty: valueNumberTelusWifiAccessPointsTelusBusiness,
            prices: {
                monthly: +(valueNumberTelusWifiAccessPointsTelusBusiness * 15),
                oneTime: 0
            }
        })
    }

    product.wifiAccess.forEach(item => {
        wifiAccessMonthly = wifiAccessMonthly + item.prices.monthly;
        wifiAccessOneTime = wifiAccessOneTime + item.prices.oneTime;
    })

    return {
        ...product,
        totalMonthly: wifiAccessMonthly,
        // totalMonthly: (staticIPRate + speedRate - promoDiscount + threeYearLtoPromoDiscount) > 0 ? (staticIPRate + speedRate - promoDiscount + threeYearLtoPromoDiscount) : 0,
        totalOneTime: wifiAccessOneTime
    };
};
